import styled from 'styled-components';

export const RatingDiv = styled.div`
    padding: 1rem 0 0 0;
`;